import { render } from "./ModalAlign.vue?vue&type=template&id=0d933db7"
import script from "./ModalAlign.vue?vue&type=script&lang=js"
export * from "./ModalAlign.vue?vue&type=script&lang=js"

import "./ModalAlign.vue?vue&type=style&index=0&id=0d933db7&lang=css"
script.render = render

export default script